import { ck } from "fire-wind-water";
import { common } from "./common";

ck.json = true;
const sconf = (window as any).$sk.config;

export function getCookieId(): string | null {
  const id: string = ck.cookie("globalUserId") || null;
  return id;
}

export function setCookieId(id): void {
  ck.cookie("globalUserId", id, {
    path: "/",
    domain: sconf.domain,
    expires: 365,
  });
}

export function removeCookieId(): void {
  ck.removeCookie(`globalUserId`, { path: "/", domain: sconf.domain });
}

export function getSession() {
  return ck.cookie(`smarketMember_${common.schemaId}`) || null;
}

export function setSession(info, expires?) {
  const o: any = {
    session: info.session,
    memberId: info.memberId,
  };
  if (info.name) {
    o.name = info.name;
  }
  if (info.unique) {
    o.unique = info.unique;
  }
  if (info.uniqueField) {
    o.uniqueField = info.uniqueField;
  }
  const options: any = {
    path: "/",
    domain: sconf.domain,
    expires,
  };
  ck.cookie(`smarketMember_${common.schemaId}`, o, options);
}

export function removeSession(): void {
  ck.removeCookie(`smarketMember_${common.schemaId}`, {
    path: "/",
    domain: sconf.domain,
  });
}

export function setVerify(id: string, token: any): void {
  ck.cookie(`verify_${id}`, token, {
    path: "/",
    domain: sconf.domain,
    expires: 1 / 12,
  });
}

export function getVerify(id: string): string | null {
  return ck.cookie(`verify_${id}`) || null;
}

export function removeVerify(id) {
  ck.removeCookie(`verify_${id}`, { path: "/", domain: sconf.domain });
}

export function setVerifyInfo(id: string, token: any): void {
  ck.cookie(`verifyInfo_${id}`, token, {
    path: "/",
    domain: sconf.domain,
    expires: 1 / 12,
  });
}

export function getVerifyInfo(id: string): string | null {
  return ck.cookie(`verifyInfo_${id}`) || null;
}

export function removeVerifyInfo(id) {
  ck.removeCookie(`verifyInfo_${id}`, { path: "/", domain: sconf.domain });
}

export function setOpenId(id: string | number, o: string) {
  ck.cookie(`openId${id}`, o, { path: "/", domain: sconf.domain });
  ck.cookie(`openid${id}`, o, { path: "/", domain: sconf.domain });
}

export function getOpenId(id) {
  return ck.cookie(`openId${id}`) || ck.cookie(`openid${id}`) || null;
}

export function removeOpenId(id) {
  ck.removeCookie(`openid${id}`, { path: "/", domain: sconf.domain });
  ck.removeCookie(`openId${id}`, { path: "/", domain: sconf.domain });
}

export function setToken(token: any): void {
  ck.cookie(`token_${common.schemaId}`, token, {
    path: "/",
    domain: sconf.domain,
  });
}

export function getToken(): string | null {
  return ck.cookie(`token_${common.schemaId}`) || null;
}

export function removeToken() {
  ck.removeCookie(`token_${common.schemaId}`, {
    path: "/",
    domain: sconf.domain,
  });
}

export function setTokenInfo(token: any): void {
  ck.cookie(`tokenInfo_${common.schemaId}`, token, {
    path: "/",
    domain: sconf.domain,
  });
}

export function getTokenInfo(): string | null {
  return ck.cookie(`tokenInfo_${common.schemaId}`) || null;
}

export function removeTokenInfo() {
  ck.removeCookie(`tokenInfo_${common.schemaId}`, {
    path: "/",
    domain: sconf.domain,
  });
}

export function setChannel(arr) {
  for (const ch in arr) {
    ck.cookie(`channel_${ch}`, arr[ch], {
      path: "/",
      domain: sconf.domain,
    });
  }
}
